import React from 'react';
import { Col, Form } from 'react-bootstrap';
import usePlacesAutocomplete, {
  getGeocode,
  getLatLng,
  getZipCode,
} from 'use-places-autocomplete';
import {
  showErrorToast,
  showSuccessToast,
} from '../../../common/helpers/Utils';

const LocationInput = ({
  labelText,
  inputName,
  value,
  placeholderText,
  formSection,
  onLocationChange,
  updateOtherFieldValue,
  errorMessage,
  disabled,
}) => {
  const {
    ready,
    value: inputValue,
    suggestions: { status, data: allSuggestions },
    setValue,
    clearSuggestions,
  } = usePlacesAutocomplete({ debounce: 300 });

  // Filter suggestions to include only "sublocality" or "locality"
  const data = allSuggestions.filter(
    (suggestion) =>
      suggestion.types.includes('sublocality') ||
      suggestion.types.includes('route') ||
      suggestion.types.includes('sublocality_level_1')
  );

  const extractLocationDetails = (components) => {
    const locationDetails = { city: '', state: '', country: '', zipcode: '' };
    components.forEach((component) => {
      const { types, long_name } = component;
      if (types.includes('postal_code')) locationDetails.zipcode = long_name;
    });

    return locationDetails;
  };

  const showError = (label) => {
    let message = '';
    message = `please select ${label} first`;
    showErrorToast(message);
    clearSuggestions();
    setValue('', false);
    updateOtherFieldValue('', 'locality', formSection);
    updateOtherFieldValue('', 'city', formSection);
    updateOtherFieldValue('', 'state', formSection);
    updateOtherFieldValue('', 'country', formSection);
    updateOtherFieldValue('', 'zipcode', formSection);
  };

  const parseAddressParts = (description) => {
    const parts = description
      .split(',')
      .map((p) => p.trim())
      .filter((p) => p);

    let country = parts.pop() || '';
    let state = parts.pop() || '';
    let city = parts.pop() || '';
    let locality = parts.join(',') || '';
    return { locality, city, state, country };
  };

  const extractFeatureName = (components) => {
    const component = components.find((comp) => comp.types.includes('route'));
    if (component) return component.long_name;

    return '';
  };

  const handleAddressSelect = async (suggestion) => {
    const { description } = suggestion;

    const { locality, city, state, country } = parseAddressParts(description);
    const missing = [];
    if (!locality) missing.push('locality');
    if (!city) missing.push('city');
    if (!state) missing.push('state');
    if (!country) missing.push('country');
    if (missing.length > 0) {
      showError(missing);
      return;
    }

    try {
      const results = await getGeocode({ address: description });

      const { lat, lng } = getLatLng(results[0]);

      const zipCode = getZipCode(results[0], false);

      const components = results[0]?.address_components || [];
      // const geoData = extractLocationDetails(components);
      const featureName = extractFeatureName(components);

      const locationDetails = {
        locality: featureName || locality,
        city,
        state,
        country,
        zipcode: zipCode || '',
        latitude: lat,
        longitude: lng,
      };

      if (inputName === 'locality') {
        setValue(description, false); //
        onLocationChange(locationDetails, formSection);
      } else {
        setValue(description, false);
        updateOtherFieldValue(
          locationDetails[inputName],
          inputName,
          formSection
        );
      }

      clearSuggestions();
    } catch (error) {
      console.error('Error fetching geocode info:', error);
      showSuccessToast('Failed to fetch address details.');
    }
  };

  const renderLocationSuggestions = () => {
    const selectedItems = data.map((suggestion) => {
      const { place_id, structured_formatting } = suggestion;
      const mainText = structured_formatting?.main_text || '';
      const secondaryText = structured_formatting?.secondary_text || '';

      const displayText = `${mainText}${
        secondaryText ? `, ${secondaryText}` : ''
      }`;

      return (
        <li
          key={place_id}
          className="location-suggestion-item"
          onClick={() => handleAddressSelect(suggestion)}
        >
          {displayText}
        </li>
      );
    });

    return selectedItems.length > 0 ? selectedItems : <h6>No data found</h6>;
  };

  console.log('value', value);
  return (
    <Form.Group className="custom-form">
      <Form.Label className="color-head form-label">{labelText}</Form.Label>
      <Form.Control
        type="text"
        className={
          inputName === 'city' ||
          inputName === 'country' ||
          inputName === 'state'
            ? 'form-control-disabled'
            : ''
        }
        value={inputValue || value}
        onChange={(e) => {
          const newValue = e.target.value;
          setValue(newValue);
          updateOtherFieldValue(newValue, inputName, formSection);
        }}
        disabled={
          !ready ||
          disabled ||
          inputName === 'city' ||
          inputName === 'country' ||
          inputName === 'state'
        }
        placeholder={placeholderText}
      />
      {status === 'OK' && (
        <ul className="location-suggestions">{renderLocationSuggestions()}</ul>
      )}
      {errorMessage && (
        <Form.Text className="text-danger">{errorMessage}</Form.Text>
      )}
    </Form.Group>
  );
};

export default LocationInput;
